<template>
  <div>
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form
        @submit.prevent="submit"
        class="d-flex flex-row justify-content-start align-items-end"
      >
        <HMTextInput
          class="mb-0"
          type="tel"
          rules="required"
          placeholder="+15017250605"
          :label="$t(title)"
          v-model="phone"
        />
        <HMButton
          class="ml-3"
          type="submit"
          color="brand"
          :loading="inProgress"
          :disabled="invalid || inProgress"
        >
          {{ $t(buttonTitle) }}
        </HMButton>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import HMTextInput from '../common/HMTextInput';
import HMButton from '../common/HMButton';
import { errorToMessage } from '../../../core/utils/errors';
import { getStudioURL } from '../../router/custom-domain-utils';

export default {
  name: 'StudentPhoneNumberComponent',
  components: { HMButton, HMTextInput, ValidationObserver },
  props: {
    title: {
      type: String,
      default: 'SETTINGS.LABEL.YOUR_PHONE_NUMBER',
    },
    buttonTitle: {
      type: String,
      default: 'GENERAL.BUTTON.UPDATE',
    },
  },
  computed: {
    studioURL() {
      return getStudioURL(this.$route);
    },
  },
  data() {
    return {
      phone: null,
      inProgress: false,
    };
  },
  methods: {
    async submit() {
      try {
        const validatedPhone = this.$filterPhone(this.phone, {
          plus: true,
          brackets: false,
          space: false,
          dash: false,
          areaCode: true,
        });
        this.inProgress = true;
        try {
          await this.$store.dispatch('studio/addStudentPhoneNumber', {
            studioURL: this.studioURL,
            phone: validatedPhone,
          });
          this.$notify({
            group: 'app',
            type: 'success',
            title: this.$t('NOTIFICATIONS.TITLE.SUCCESS'),
            text: this.$t(
              'NOTIFICATIONS.TEXT.PHONE_NUMBER_SUCCESSFULLY_UPDATED'
            ),
          });
        } catch (error) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: errorToMessage(error.response),
          });
        } finally {
          this.inProgress = false;
        }
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Invalid phone number',
          text:
            'Please include the plus sign, your area code, no brackets, no spaces, no dashes',
        });
      }
    },
  },
};
</script>

<style scoped></style>
